export default __webpack_public_path__ + "static/media/sx.1775ef4c.svg";